import IPT from 'react-immutable-proptypes';
import PT from 'prop-types';

export default {
  question: IPT.map,
  response: IPT.map,
  onSubmit: PT.func,
  onSubmitGrok: PT.func,
  grokkingItemIsSaving: PT.bool,
  onQuestionComplete: PT.func,
  isLastQuestion: PT.bool,
  isQuestionReview: PT.bool,
};
